import { Actions } from '../actions';
export var Steps;
(function (Steps) {
    Steps["REGISTER"] = "register";
    Steps["QUESTIONNAIRE"] = "questionnaire";
    Steps["SUCCESS"] = "success";
})(Steps || (Steps = {}));
export const defaultState = {
    form: undefined,
    step: Steps.REGISTER,
};
export default function registerReducer(state = defaultState, action) {
    const { payload } = action;
    switch (action.type) {
        case Actions.RegisterSetData:
            return {
                ...state,
                form: {
                    ...state.form,
                    ...payload,
                },
                step: Steps.QUESTIONNAIRE,
            };
        case Actions.QuestionnaireSetData:
            return {
                ...state,
                form: {
                    ...state.form,
                    ...payload,
                },
                step: Steps.SUCCESS,
            };
        default:
            return state;
    }
}
